module.exports = __webpack_public_path__ + "static/img/20.afb7b44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/eng/20.png
// module id = 20qG
// module chunks = 0